import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface UpdateAvailableStore {
  updateAvailable: boolean;

  setUpdateAvailable: (newBoolean: boolean) => void;
}

const useUpdateAvailableStore = createWithEqualityFn<UpdateAvailableStore>(
  (set) => ({
    updateAvailable: false,

    setUpdateAvailable(newBoolean: boolean) {
      set(() => ({ updateAvailable: newBoolean }));
    },
  }),
  shallow
);

export default useUpdateAvailableStore;
